export default __webpack_public_path__ + "locales/pt/Article.json?hash=8954ad08bb74e5cb993a22fa68e77510";